import axios from '@/utils/axios'
//充值档位组件列表
export function gearList(query) {
    return axios({
        url: '/video/rechargeTemplate/list',
        method: 'get',
        params: query
    })
}

//档位详情
export function gearDetails(query) {
    return axios({
        url: '/video/rechargeTemplate/addOrUpdTemplate',
        method: 'get',
        params: query
    })
}

// 档位添加
export function gearAdd(query) {
    return axios({
        url: '/video/rechargeTemplate/addOrUpdTemplate/save',
        method: 'post',
        params: query
    })
}

// 档位删除
export function gearDel(query) {
    return axios({
        url: '/video/rechargeTemplate/delTemplate/save',
        method: 'post',
        params: query
    })
}

//充值方案-列表
export function planList(query) {
    return axios({
        url: '/video/rechargeTemplate/plan/list',
        method: 'get',
        params: query
    })
}

// 充值方案-详情
export function planDetails(query) {
    return axios({
        url: '/video/rechargeTemplate/getRechargePlanConfigInfo',
        method: 'get',
        params: query
    })
}

// 充值方案-添加
export function planAdd(query) {
    return axios({
        url: '/video/rechargeTemplate/addOrEditRechargePlanInfo/save',
        method: 'post',
        params: query
    })
}

// 充值方案配置-添加档位
export function planAddGear(query) {
    return axios({
        url: '/video/rechargeTemplate/addPlanTemplateData/save',
        method: 'post',
        params: query
    })
}
// 删除已配置的档位
export function planDelGear(query) {
    return axios({
        url: '/video/rechargeTemplate/delConfigTemplate/save',
        method: 'post',
        params: query
    })
}

//方案档位排序
export function planOrder(query) {
    return axios({
        url: '/video/rechargeTemplate/planData/order',
        method: 'post',
        params: query
    })
}